import {
    MyAccountQuery as SourceMyAccountQuery
} from 'SourceQuery/MyAccount.query';
import { Field } from 'Util/Query';

/**
 * MyAccount Mutations
 * @class MyAccount
 * @namespace Scandipwa/Query/MyAccount/Query */
export class MyAccountQuery extends SourceMyAccountQuery {
    _getCustomerFields() {
        return [
            'created_at',
            'confirmation_required',
            'group_id',
            'prefix',
            'firstname',
            'middlename',
            'lastname',
            'suffix',
            'email',
            'default_billing',
            'default_shipping',
            'dob',
            'taxvat',
            'id',
            'is_subscribed',
            // Using alternate config key to prevent collisions with PWA core configuration
            'is_subscribed_bool',
            this._getAddressesField()
        ];
    }

    getEmarsysPreferencesLink(email) {
        return new Field('EmarsysGetPreferences')
            .addArgument('email', 'String!', email);
    }
}

export default new MyAccountQuery();
